import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import  './Resources/Actions.css';
import './App.css';

export default function Ledgerview(){
    const navigate = useNavigate();
    const location = useLocation();
    const [rdetail,setRdetail]= useState([]);
    const {ldetail,loanNo,guarantorid} = location.state;
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [guarantor,setGuarantor] = useState([]);
    
    console.log(guarantorid);
    

    useEffect(()=>
    {
        fetch(API_URL+"api/Payment/GetPayments?id="+ loanNo)
        .then(response => response.json())
        .then(data => {setRdetail(data)});

        fetch(API_URL+"api/Customer/GetCustomer?id="+guarantorid)
        .then(response => response.json())
        .then(data1 => {setGuarantor(data1)});
    },[]);

    
    

    const loan = ldetail.filter(el => {if(el.LoanNo === loanNo){ return el }})
    const Total = rdetail.length > 0 ? rdetail.reduce((tot,el)=>tot+ el.RAmount,0) : 0;
    
    console.log(guarantor);
    console.log(loan);
   return(
        <>
        <Navbar/>
        <div style={{height:"30px", width:"100%",paddingTop:"10px",paddingLeft:"10px",backgroundColor:"blue",color:"white",textAlign:"left"}}>Ledger</div>
            
        <div style={{backgroundColor:"goldenrod",height:"30px",width:"100%",fontSize:"20px",fontWeight:"bolder",textAlign:"center",zIndex:-1}}>{loan[0].CustomerName}</div>

        <div style={{backgroundColor:"lightskyblue",fontWeight:"bolder",  height:"30px",width:"100%",textAlign:"center",zIndex:-1}} > Loan Number: {loan[0].AccountNo} </div>
        <div style={{backgroundColor:"lightskyblue",fontWeight:"normal",  height:"30px",width:"100%",textAlign:"center",zIndex:-1}}> Guarantor: {guarantor.length > 0 ? guarantor[0].CustomerName:"Self"} </div>
        
            <table style={{width:"100%",marginBottom:"40px",backgroundColor:"lightskyblue"}}>
                <tr>
                    <th>Date</th>
                    <th>R.No</th>
                    <th>Loan</th>
                    <th>Fine</th>
                    <th>Paid</th>
                </tr>
                <tr>
                 <td> {loan[0].LoanDate.slice(8,10)}-{loan[0].LoanDate.slice(5,7)}-{loan[0].LoanDate.slice(0,4)} </td>
                 <td></td>
                 <td> {loan[0].LoanAmount}</td>
                 <td></td>
                 <td></td>
                </tr>
                {rdetail.map(cus => {return(<tr>
                    <td>{cus.RDate.slice(8,10)}-{cus.RDate.slice(5,7)}-{cus.RDate.slice(0,4)}</td>
                    <td>{cus.ReceiptNo}</td>
                    <td></td>
                    <td>{cus.RFine}</td>
                    <td>{cus.RAmount}</td>
                </tr>)})}
                
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                
                <tr>
                    <td></td>
                    <td style={{fontWeight:"bolder"}}>Total</td>
                    <td style={{fontWeight:"bolder"}}>{loan[0].LoanAmount}</td>
                    <td></td>
                    <td style={{fontWeight:"bolder"}}>{Total}</td>
                </tr>
                <tr>

                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{fontWeight:"bolder"}}>Balance</td>
                    <td style={{fontWeight:"bolder"}}>{loan[0].LoanAmount-Total}</td>
                </tr>
            </table>
 
        <button type="button" className="backbutton" onClick={()=>{navigate('/customerledger')}}>Back</button>

        </>
    )

}